import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

interface IPath {
  from: { pathname: string };
}

function useRedirectTo(): IPath {
  const [currentLocationState, setCurrentLocationState] = useState<IPath>({
    from: { pathname: '/' },
  });
  const location = useLocation();

  useEffect(() => {
    if (location.state) {
      setCurrentLocationState(location.state as IPath);
    }
  }, [location.state]);

  return currentLocationState;
}

export default useRedirectTo;
